import { render } from "./LogoWhite.vue?vue&type=template&id=7ff95da2"
import script from "./LogoWhite.vue?vue&type=script&lang=js"
export * from "./LogoWhite.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__